<template>
    <div>
        <loading-spinner v-if="loading" height="" size="30" width="2" color="accent"/>
        <v-row v-else>
            <v-col cols="12" v-for="injury in injuries" :key="injury.id">
                <div class="kimsa-elevation card-container p-relative">
                    {{ getInjuryName(injury) }}

                    <v-btn v-if="!readonly" color="primary" fab x-small depressed class="edit-btn" @click="loadInjury(injury)">
                        <v-icon color="black">$edit</v-icon>
                    </v-btn>
                </div>
            </v-col>
            <v-col cols="12" v-if="injuries.length === 0">
                <div class="kimsa-elevation card-container p-relative">
                    {{ $t('common.without_injuries') }}
                </div>
            </v-col>
        </v-row>

        <injury-form-dialog ref="injury" @success="loadInjuries"/>
    </div>
</template>

<script>
import InjuryFormDialog from "@/components/student/InjuryFormDialog";
import {db} from "@/utils/Firebase";
import LoadingSpinner from "@/components/common/LoadingSpinner";

export default {
    name: "InjuriesCard",
    components: {LoadingSpinner, InjuryFormDialog},
    props: {
        studentId: {
            type: String,
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            loading: false,
            injuries: [],
        }
    },
    async mounted() {
        const vm = this
        await vm.loadInjuries()
    },
    methods: {
        showInjuryForm() {
            const vm = this
            vm.$refs.injury.show()
        },
        async loadInjuries() {
            const vm = this
            vm.loading = true
            vm.injuries = []

            let ref = await db.collection('injuries')
                .where('studentId', '==', vm.studentId)
                .orderBy('date', 'desc')
                .limit(3)
                .get()
            vm.injuries = ref.docs.map(injury => ({
                ...injury.data(),
                id: injury.id,
            }))

            vm.loading = false
        },
        loadInjury(injury) {
            const vm = this
            vm.$refs.injury.loadInjury(injury)
        },
        getInjuryName(injury) {
            const vm = this
            let date = vm.$moment(injury.date).format('MMMM YYYY')
            return `${injury.type} ${injury.zone} - ${date}`
        }
    },
}
</script>

<style scoped>

.edit-btn {
    position: absolute;
    top: 0;
    right: -10px;
    border: 1px solid #333333 !important;
    z-index: 1;
}

.card-container {
    padding: 16px 12px;
    color: var(--v-accent-base);
    font-weight: bold;
    font-size: 13px;
    text-transform: capitalize;
}

</style>